import React from 'react';
import FieldOptionsTab from './FieldOptionsTab';

const IdentityPreferencesTab = (props) => (
  <FieldOptionsTab
    title="Identity Preferences"
    description='Manage fields and their options (e.g. "I am a" → Man, Women, Others)'
    emptyMessage='No identity fields yet. Click "Add Field" to create one.'
    fieldPlaceholder='e.g. "I am a:"'
    optionPlaceholder='e.g. "Man", "Women", "Others"'
    saveErrorMessage="Failed to save identity preferences"
    activityPrefix="identity"
    {...props}
  />
);

export default IdentityPreferencesTab;
